import React, { useState, useEffect, useRef } from 'react';
import { TrendingUp, AlertTriangle, Shield, ArrowRight, Search, Check, Loader2, Upload, Star, X } from 'lucide-react';

// СБП Icon Component
const SBPIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 97 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z" fill="#5B57A2"/>
    <path d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z" fill="#D90751"/>
    <path d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z" fill="#FAB718"/>
    <path d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z" fill="#ED6F26"/>
    <path d="M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z" fill="#63B22F"/>
    <path d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z" fill="#1487C9"/>
    <path d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z" fill="#017F36"/>
    <path d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z" fill="#984995"/>
  </svg>
);

// ВТБ Icon Component
const VTBIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 92 33" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <path d="M6.25065367,0 L4.68701481,4.28311036 L26.3555573,4.28311036 L27.9191962,0 L6.25065367,0 Z M3.90470765,6.423693 L2.34106879,10.7058308 L24.0096113,10.7058308 L25.5732502,6.423693 L3.90470765,6.423693 Z M1.56363886,12.847386 L0,17.1295238 L21.6685425,17.1295238 L23.231206,12.847386 L1.56363886,12.847386 Z" fill="#38BDF8"/>
        <path d="M46.0659305,18.7617116 L46.0659305,18.8520825 C47.0561913,19.215552 48.002112,19.8511271 48.497735,20.2592855 C50.0289442,21.5304356 50.7048834,23.2097442 50.7048834,25.3885751 C50.7048834,28.975602 48.8130419,31.5625912 45.7052982,32.3799011 C44.7593775,32.6520067 43.7691167,32.7433706 41.9216153,32.7433706 L32.5097041,32.7433706 L32.5097041,6.50603633 L40.8416891,6.50603633 C42.5532145,6.50603633 43.7237914,6.59640716 44.7593775,6.86851275 C47.7774558,7.68582259 49.7589627,9.77428262 49.7589627,13.0872178 C49.7589627,14.8578903 49.1283488,16.3564572 48.0927627,17.3545087 C47.642465,17.808349 47.0118512,18.3535533 46.0659305,18.7617116 Z M37.7339454,21.5304356 L37.7339454,28.4303977 L41.3373122,28.4303977 C42.4172384,28.4303977 43.4084845,28.3400269 44.129749,27.6587698 C44.8500282,26.9775128 45.1653351,26.1155141 45.1653351,24.9804167 C45.1653351,24.118418 44.9396936,23.3011081 44.489396,22.711215 C43.7237914,21.7578524 42.7778706,21.5304356 41.1569961,21.5304356 L37.7339454,21.5304356 Z M37.6886201,16.9910392 L40.6160476,16.9910392 C41.516643,16.9910392 41.9669407,16.9910392 42.4172384,16.8549864 C43.634126,16.4915169 44.3997305,15.4030945 44.3997305,13.9045276 C44.3997305,12.1348482 43.5888006,11.3622273 42.4172384,10.9997508 C41.9216153,10.863698 41.4269776,10.8180161 40.4357315,10.8180161 L37.6886201,10.8180161 L37.6886201,16.9910392 Z M58.5412454,32.7433706 L58.5412454,10.9083869 L51.0201903,10.9083869 L51.0201903,6.50603633 L71.918141,6.50603633 L70.4322572,10.9083869 L63.7654868,10.9083869 L63.7654868,32.7433706 L58.5412454,32.7433706 Z M73.5390156,32.7433706 L73.5390156,6.50603633 L90.4739526,6.50603633 L88.9880688,10.9083869 L78.7189169,10.9083869 L78.7189169,16.7189336 L82.9075721,16.7189336 C86.2852974,16.7189336 88.0421481,17.5362434 89.2580504,18.5799769 C90.2039711,19.3972867 91.8248457,21.2126481 91.8248457,24.799675 C91.8248457,28.3400269 90.1586457,30.291441 88.7624273,31.2904856 C87.1415527,32.4245899 85.4300274,32.7433706 81.9616514,32.7433706 L73.5390156,32.7433706 Z M78.7189169,28.3400269 L82.6375906,28.3400269 C84.1234744,28.3400269 85.0240698,27.9765574 85.6546836,27.1592475 C85.9699905,26.7510892 86.4202882,26.0241502 86.4202882,24.6626291 C86.4202882,23.3011081 85.9699905,22.3477455 85.0693951,21.6664884 C84.5294321,21.2583301 83.8081675,21.0319064 82.5922652,21.0319064 L78.7189169,21.0319064 L78.7189169,28.3400269 Z" fill="#60A5FA"/>
      </g>
    </g>
  </svg>
);

// USDT Icon
const USDTIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#26A17B"/>
    <path d="M17.922 17.383v-.002c-.11.008-.677.042-1.942.042-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658 0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061 1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658 0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118 0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116 0-1.043-3.301-1.914-7.694-2.117" fill="white"/>
  </svg>
);

// Alipay Icon
const AlipayIcon = ({ className = "w-8 h-8" }) => (
<img 
    src="/alipay-12.png" 
    alt="Alipay" 
    className={`${className} rounded-full object-cover`}
  />
);

// TRC-20 (TRON) Icon
const TronIcon = ({ className = "w-10 h-10" }) => (
  <img 
    src="/tron-logo.png" 
    alt="TRC-20" 
    className={`${className} rounded-full object-cover`}
  />
);

// Bybit Icon
const BybitIcon = ({ className = "w-10 h-10" }) => (
  <img 
    src="/bybit-logo.png" 
    alt="Bybit" 
    className={`${className} rounded-lg object-cover`}
  />
);

const DepositScreen = ({ 
  paymentMethod, 
  setPaymentMethod,
  amount,
  setAmount,
  fullName,
  setFullName,
  qrCode,
  setQrCode,
  selectedBank,
  setSelectedBank,
  usdtNetwork,
  setUsdtNetwork,
  exchangeRate,
  usdtToCnyRate,
  handleAlipayDeposit,
  limits,
  paymentLimits,
  verificationStatus,
  sbpBanks,
  setCurrentScreen,
  calculateAmount,
  calculatedAmount,
  isSubmitting,
}) => {
  const [bankSearch, setBankSearch] = useState('');
  const debounceRef = useRef(null);
  
  // Согласия с документами
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  
  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    
    if (amount && parseFloat(amount) > 0 && calculateAmount && paymentMethod) {
      debounceRef.current = setTimeout(() => {
        calculateAmount(amount, 'alipay', paymentMethod);
      }, 500);
    }
    
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [amount, calculateAmount, paymentMethod]);
  
  const isAdmin = verificationStatus?.isAdmin || false;
  const isVerified = verificationStatus?.isVerified || isAdmin || false;
  const isVerificationLoading = verificationStatus?.isLoading || false;

  const banks = sbpBanks?.length > 0 
    ? sbpBanks.filter(b => b.id !== 'vtb' && b.name !== 'ВТБ') 
    : [
      { id: 'tinkoff', name: 'Т-Банк' },
      { id: 'sber', name: 'Сбербанк' },
      { id: 'alfa', name: 'Альфа Банк' },
      { id: 'raif', name: 'Райффайзен Банк' },
      { id: 'gazprom', name: 'Газпромбанк' },
      { id: 'ozon', name: 'Озон Банк' },
      { id: 'rosbank', name: 'Росбанк' },
      { id: 'psb', name: 'ПСБ' },
      { id: 'mts', name: 'МТС Банк' },
      { id: 'sovkom', name: 'Совкомбанк' },
    ];

  const filteredBanks = banks.filter(bank => 
    bank.name.toLowerCase().includes(bankSearch.toLowerCase())
  );

  const getCurrentLimits = () => {
    if (paymentMethod === 'RUB_SBP' && paymentLimits?.sbp) return paymentLimits.sbp;
    if (paymentMethod === 'RUB_VTB' && paymentLimits?.vtb) return paymentLimits.vtb;
    return null;
  };

  const currentLimits = getCurrentLimits();
  
  // Минимальная сумма (в рублях)
  const MIN_AMOUNT_RUB = 2000;
  
  // Проверка лимитов
  const getAmountValidation = () => {
    if (!amount || !paymentMethod || paymentMethod === 'USDT') return null;
    
    const amountValue = parseFloat(amount);
    if (isNaN(amountValue) || amountValue <= 0) return null;
    
    // Проверка минимальной суммы
    if (amountValue < MIN_AMOUNT_RUB) {
      return {
        type: 'min',
        message: `Минимальная сумма: ${MIN_AMOUNT_RUB.toLocaleString()} ₽`
      };
    }
    
    // Проверка лимитов
    if (currentLimits) {
      // Сначала проверяем дневной лимит (он обычно меньше)
      const dailyRemaining = currentLimits.daily?.remaining;
      const monthlyRemaining = currentLimits.monthly?.remaining;
      const perTransaction = currentLimits.perTransaction;
      
      // Находим минимальный доступный лимит
      const availableLimits = [dailyRemaining, monthlyRemaining, perTransaction].filter(l => l !== undefined && l !== null);
      const maxAvailable = availableLimits.length > 0 ? Math.min(...availableLimits) : null;
      
      if (maxAvailable !== null && amountValue > maxAvailable) {
        return {
          type: 'limit',
          message: `Превышен лимит. Доступно: ${maxAvailable.toLocaleString()} ₽`,
          available: maxAvailable
        };
      }
    }
    
    return null;
  };
  
  const amountValidation = getAmountValidation();

  // Verification required screen
  if (!isVerificationLoading && !isVerified) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black p-4 pb-8">
        <div className="max-w-md mx-auto pt-20">
          
          {/* Header */}
          <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
            <div className="flex items-center gap-4">
              <div className="bg-blue-500/20 rounded-xl p-3">
                <AlipayIcon className="w-6 h-6" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Пополнить Alipay</h1>
                <p className="text-gray-500 text-sm">Создание заявки на пополнение</p>
              </div>
            </div>
          </div>

          {/* Verification Required Badge */}
          <div className="bg-amber-500/10 rounded-2xl p-4 mb-4 border border-amber-500/30 flex items-center gap-3">
            <AlertTriangle className="w-5 h-5 text-amber-400" />
            <span className="text-sm text-amber-300 font-medium">Требуется KYC верификация</span>
          </div>

          {/* Info Card */}
          <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-4">Зачем нужна верификация</h2>
            <div className="space-y-3">
              <div className="flex items-center gap-3 py-2 border-b border-gray-700/50">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-400" />
                <span className="text-gray-300 text-sm">Безопасность ваших средств</span>
              </div>
              <div className="flex items-center gap-3 py-2 border-b border-gray-700/50">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-400" />
                <span className="text-gray-300 text-sm">Соответствие требованиям платежной системы</span>
              </div>
              <div className="flex items-center gap-3 py-2">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-400" />
                <span className="text-gray-300 text-sm">Возможность работы в "белую"</span>
              </div>
            </div>
          </div>

          {/* How it works */}
          <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-4">Как пройти верификацию</h2>
            <div className="space-y-3">
              <div className="flex items-center gap-3 py-2 border-b border-gray-700/50">
                <Shield className="w-4 h-4 text-gray-500" />
                <span className="text-gray-300 text-sm">Введите номер телефона</span>
              </div>
              <div className="flex items-center gap-3 py-2 border-b border-gray-700/50">
                <Shield className="w-4 h-4 text-gray-500" />
                <span className="text-gray-300 text-sm">Подтвердите SMS-кодом</span>
              </div>
              <div className="flex items-center gap-3 py-2">
                <Shield className="w-4 h-4 text-gray-500" />
                <span className="text-gray-300 text-sm">Заполните паспортные данные</span>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <button
            onClick={() => setCurrentScreen('profile')}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white rounded-2xl py-4 px-5 font-medium transition-all flex items-center justify-center gap-2"
          >
            <span>Пройти верификацию</span>
            <ArrowRight className="w-5 h-5" />
          </button>
          
          {/* Footer note */}
          <p className="text-center text-xs text-gray-600 mt-4">Верификация занимает 2-3 минуты</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black p-4 pb-8">
      <div className="max-w-md mx-auto pt-20">
        
        {/* Header */}
        <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
          <div className="flex items-center gap-4">
            <div className="bg-blue-500/20 rounded-xl p-3">
              <AlipayIcon className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Пополнить Alipay</h1>
              <p className="text-gray-500 text-sm">Создание заявки на пополнение</p>
            </div>
          </div>
        </div>

        {/* Verification Status */}
        <div className={`rounded-2xl p-4 mb-4 border flex items-center gap-3 ${
          isAdmin 
            ? 'bg-purple-500/10 border-purple-500/30' 
            : 'bg-green-500/10 border-green-500/30'
        }`}>
          {isAdmin ? (
            <>
              <Star className="w-5 h-5 text-purple-400" />
              <span className="text-sm text-purple-300 font-medium">Администратор</span>
            </>
          ) : (
            <>
              <Shield className="w-5 h-5 text-green-400" />
              <span className="text-sm text-green-300 font-medium">Верификация пройдена</span>
            </>
          )}
        </div>

        {/* Payment Method Selection */}
        <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
          <h2 className="text-sm font-medium text-gray-400 mb-4">Способ оплаты</h2>
          <div className="grid grid-cols-3 gap-2">
            <button
              onClick={() => {
                setPaymentMethod('RUB_SBP');
                setSelectedBank('');
                setUsdtNetwork('');
              }}
              className={`py-4 px-2 rounded-xl transition-all flex flex-col items-center gap-2 ${
                paymentMethod === 'RUB_SBP'
                  ? 'bg-blue-600/20 ring-2 ring-blue-500 border-transparent'
                  : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
              }`}
            >
              <SBPIcon className="w-8 h-8" />
              <span className={`text-xs font-medium ${paymentMethod === 'RUB_SBP' ? 'text-blue-400' : 'text-gray-400'}`}>СБП</span>
            </button>

            <button
              onClick={() => {
                setPaymentMethod('RUB_VTB');
                setSelectedBank('vtb');
                setUsdtNetwork('');
              }}
              className={`py-4 px-2 rounded-xl transition-all flex flex-col items-center gap-2 ${
                paymentMethod === 'RUB_VTB'
                  ? 'bg-blue-600/20 ring-2 ring-blue-500 border-transparent'
                  : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
              }`}
            >
              <VTBIcon className="w-10 h-5" />
              <span className={`text-xs font-medium ${paymentMethod === 'RUB_VTB' ? 'text-blue-400' : 'text-gray-400'}`}>ВТБ</span>
            </button>

            <button
              onClick={() => {
                setPaymentMethod('USDT');
                setSelectedBank('');
                setUsdtNetwork('');
              }}
              className={`py-4 px-2 rounded-xl transition-all flex flex-col items-center gap-2 ${
                paymentMethod === 'USDT'
                  ? 'bg-emerald-600/20 ring-2 ring-emerald-500 border-transparent'
                  : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
              }`}
            >
              <USDTIcon className="w-8 h-8" />
              <span className={`text-xs font-medium ${paymentMethod === 'USDT' ? 'text-emerald-400' : 'text-gray-400'}`}>USDT</span>
            </button>
          </div>
        </div>

        {/* Limits Card */}
        {currentLimits && (
          <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-4 flex items-center gap-2">
              {paymentMethod === 'RUB_SBP' && <SBPIcon className="w-4 h-4" />}
              {paymentMethod === 'RUB_VTB' && <VTBIcon className="w-5 h-3" />}
              Лимиты {currentLimits.name}
            </h2>
            <div className="space-y-4">
              <div className="flex items-center justify-between py-2 border-b border-gray-700/50">
                <span className="text-gray-400 text-sm">На транзакцию</span>
                <span className="text-white font-medium">{currentLimits.perTransaction?.toLocaleString()} RUB</span>
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-400 text-sm">Дневной</span>
                  <span className="text-white text-sm">
                    {currentLimits.daily?.used?.toLocaleString()} / {currentLimits.daily?.limit?.toLocaleString()} RUB
                  </span>
                </div>
                <div className="w-full h-1.5 bg-gray-700 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-blue-500 rounded-full transition-all"
                    style={{ width: `${Math.min(currentLimits.daily?.percent || 0, 100)}%` }}
                  />
                </div>
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-400 text-sm">Месячный</span>
                  <span className="text-white text-sm">
                    {currentLimits.monthly?.used?.toLocaleString()} / {currentLimits.monthly?.limit?.toLocaleString()} RUB
                  </span>
                </div>
                <div className="w-full h-1.5 bg-gray-700 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-purple-500 rounded-full transition-all"
                    style={{ width: `${Math.min(currentLimits.monthly?.percent || 0, 100)}%` }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* USDT No Limits Notice */}
        {paymentMethod === 'USDT' && (
          <div className="bg-emerald-500/10 rounded-2xl p-4 mb-4 border border-emerald-500/30 flex items-center gap-3">
            <USDTIcon className="w-6 h-6" />
            <div>
              <span className="font-medium text-emerald-400 text-sm">Без лимитов</span>
              <p className="text-xs text-gray-400">На переводы USDT лимиты не распространяются</p>
            </div>
          </div>
        )}

        {/* Bank Selection for SBP */}
        {paymentMethod === 'RUB_SBP' && (
          <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-4">
              {selectedBank ? 'Выбранный банк' : 'Выберите банк'}
            </h2>
            
            {selectedBank ? (
              // Показываем выбранный банк с кнопкой отмены
              <div className="bg-blue-600/20 rounded-xl p-4 border border-blue-500/30 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-blue-400" />
                  <span className="text-blue-400 font-medium">
                    {banks.find(b => (b.id || b.name) === selectedBank)?.name || selectedBank}
                  </span>
                </div>
                <button
                  onClick={() => setSelectedBank('')}
                  className="p-1.5 rounded-lg bg-gray-800/50 hover:bg-gray-700 transition-all"
                >
                  <X className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            ) : (
              // Показываем список банков
              <>
                <div className="relative mb-3">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
                  <input
                    type="text"
                    value={bankSearch}
                    onChange={(e) => setBankSearch(e.target.value)}
                    placeholder="Поиск банка..."
                    className="w-full pl-9 pr-4 py-3 bg-gray-900/50 border border-gray-700/50 rounded-xl focus:border-blue-500 focus:outline-none transition-all text-white text-sm placeholder-gray-500"
                  />
                </div>
                <div className="bg-gray-900/30 rounded-xl border border-gray-700/30 overflow-hidden max-h-48 overflow-y-auto">
                  {filteredBanks.map((bank, index) => (
                    <button
                      key={bank.id || bank.name}
                      onClick={() => setSelectedBank(bank.id || bank.name)}
                      className={`w-full px-4 py-3 flex items-center justify-between transition-all text-gray-300 hover:bg-gray-800/50 ${
                        index !== filteredBanks.length - 1 ? 'border-b border-gray-800/50' : ''
                      }`}
                    >
                      <span className="text-sm">{bank.name}</span>
                    </button>
                  ))}
                  {filteredBanks.length === 0 && (
                    <div className="px-4 py-6 text-center text-gray-500 text-sm">
                      Банк не найден
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {/* USDT Network Selection */}
        {paymentMethod === 'USDT' && (
          <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-4">Способ перевода</h2>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => setUsdtNetwork('TRC-20')}
                className={`py-4 px-3 rounded-xl transition-all flex flex-col items-center gap-2 ${
                  usdtNetwork === 'TRC-20'
                    ? 'bg-red-600/20 ring-2 ring-red-500 border-transparent'
                    : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
                }`}
              >
                <TronIcon className="w-10 h-10" />
                <div className="text-center">
                  <p className={`text-sm font-medium ${usdtNetwork === 'TRC-20' ? 'text-red-400' : 'text-gray-300'}`}>TRC-20</p>
                  <p className="text-xs text-gray-500">Сеть TRON</p>
                </div>
              </button>
              <button
                onClick={() => setUsdtNetwork('Bybit')}
                className={`py-4 px-3 rounded-xl transition-all flex flex-col items-center gap-2 ${
                  usdtNetwork === 'Bybit'
                    ? 'bg-orange-600/20 ring-2 ring-orange-500 border-transparent'
                    : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
                }`}
              >
                <BybitIcon className="w-10 h-10" />
                <div className="text-center">
                  <p className={`text-sm font-medium ${usdtNetwork === 'Bybit' ? 'text-orange-400' : 'text-gray-300'}`}>Bybit</p>
                  <p className="text-xs text-gray-500">Внутренний</p>
                </div>
              </button>
            </div>
          </div>
        )}

        {/* Order Details Form */}
        <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
          <h2 className="text-sm font-medium text-gray-400 mb-4">Детали заявки</h2>
          
          <div className="space-y-4">
            {/* Amount */}
            <div>
              <label className="block text-sm text-gray-400 mb-2">
                {paymentMethod === 'USDT' ? 'Сумма в USDT' : 'Сумма в рублях (RUB)'}
              </label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Введите сумму"
                className={`w-full px-4 py-3 bg-gray-900/50 border rounded-xl focus:outline-none transition-all text-white placeholder-gray-500 ${
                  amountValidation ? 'border-red-500/50 focus:border-red-500' : 'border-gray-700/50 focus:border-blue-500'
                }`}
              />
              
              {/* Предупреждение о лимитах */}
              {amountValidation && (
                <div className="mt-2 flex items-center gap-2 text-sm">
                  <AlertTriangle className="w-4 h-4 text-red-400" />
                  <span className="text-red-400">{amountValidation.message}</span>
                </div>
              )}
              
              {/* Курс конвертации */}
              {amount && paymentMethod && !amountValidation && (
                <div className="mt-2 flex items-center gap-2 text-sm">
                  {calculatedAmount?.loading ? (
                    <>
                      <Loader2 className="w-4 h-4 text-blue-400 animate-spin" />
                      <span className="text-gray-400">Расчет...</span>
                    </>
                  ) : (
                    <>
                      <TrendingUp className="w-4 h-4 text-blue-400" />
                      <span className="text-gray-400">Вы получите:</span>
                      <span className="font-medium text-blue-400">
                        {paymentMethod === 'USDT' 
                          ? `${calculatedAmount?.cny || (parseFloat(amount) * (usdtToCnyRate || 7.2)).toFixed(2)} CNY`
                          : `${calculatedAmount?.cny || (parseFloat(amount) / (exchangeRate || 11.74)).toFixed(2)} CNY`}
                      </span>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* Full Name */}
            <div>
              <label className="block text-sm text-gray-400 mb-2">Имя и Фамилия (латиницей)</label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Ivan Ivanov"
                className="w-full px-4 py-3 bg-gray-900/50 border border-gray-700/50 rounded-xl focus:border-blue-500 focus:outline-none transition-all text-white placeholder-gray-500"
              />
              <div className="mt-2 flex items-start gap-2">
                <Shield className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                <p className="text-xs text-amber-400/80">
                  ФИО должны совпадать с данными KYC и картой, с которой производится оплата
                </p>
              </div>
            </div>

            {/* QR Code Upload */}
            <div>
              <label className="block text-sm text-gray-400 mb-2">QR код Alipay</label>
              <div className="relative">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setQrCode(e.target.files[0])}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                />
                <div className={`w-full px-4 py-3 rounded-xl border transition-all flex items-center gap-3 ${
                  qrCode 
                    ? 'bg-green-500/10 border-green-500/30' 
                    : 'bg-gray-900/50 border-gray-700/50 hover:border-gray-600'
                }`}>
                  {qrCode ? (
                    <>
                      <Check className="w-5 h-5 text-green-400" />
                      <span className="text-green-400 text-sm truncate">{qrCode.name}</span>
                    </>
                  ) : (
                    <>
                      <Upload className="w-5 h-5 text-gray-500" />
                      <span className="text-gray-500 text-sm">Выберите файл</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Согласия с документами */}
        <div className="bg-gray-800/50 rounded-2xl p-4 mb-4 border border-gray-700/50">
          <div className="space-y-3">
            <label className="flex items-center gap-3 cursor-pointer group p-2 rounded-xl hover:bg-gray-700/30 transition-all">
              <div className="relative flex-shrink-0">
                <input
                  type="checkbox"
                  checked={privacyAccepted}
                  onChange={(e) => setPrivacyAccepted(e.target.checked)}
                  className="sr-only"
                />
                <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all ${
                  privacyAccepted 
                    ? 'bg-blue-600 border-blue-600 shadow-lg shadow-blue-600/30' 
                    : 'border-gray-500 group-hover:border-blue-400'
                }`}>
                  {privacyAccepted && <Check className="w-4 h-4 text-white" />}
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm text-gray-200">
                  Я принимаю{' '}
                  <a 
                    href={encodeURI("/Политика конфеденциальности.pdf")}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-400 hover:text-blue-300 underline font-medium"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Политику конфиденциальности
                  </a>
                </span>
              </div>
            </label>
            
            <div className="border-t border-gray-700/50"></div>
            
            <label className="flex items-center gap-3 cursor-pointer group p-2 rounded-xl hover:bg-gray-700/30 transition-all">
              <div className="relative flex-shrink-0">
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                  className="sr-only"
                />
                <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all ${
                  termsAccepted 
                    ? 'bg-blue-600 border-blue-600 shadow-lg shadow-blue-600/30' 
                    : 'border-gray-500 group-hover:border-blue-400'
                }`}>
                  {termsAccepted && <Check className="w-4 h-4 text-white" />}
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm text-gray-200">
                  Я принимаю{' '}
                  <a 
                    href={encodeURI("/Пользовательское соглашение.pdf")}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-400 hover:text-blue-300 underline font-medium"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Пользовательское соглашение
                  </a>
                </span>
              </div>
            </label>
          </div>
        </div>

        {/* Submit Button */}
        <button
          onClick={handleAlipayDeposit}
          disabled={
            isSubmitting ||
            !paymentMethod || 
            !amount || 
            !fullName || 
            !qrCode ||
            (paymentMethod === 'RUB_SBP' && !selectedBank) ||
            (paymentMethod === 'USDT' && !usdtNetwork) ||
            !privacyAccepted ||
            !termsAccepted ||
            !!amountValidation
          }
          className="w-full bg-blue-600 hover:bg-blue-500 disabled:bg-gray-700 disabled:cursor-not-allowed text-white rounded-2xl py-4 px-5 font-medium transition-all flex items-center justify-center gap-2"
        >
          {isSubmitting ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              <span>Создание заявки...</span>
            </>
          ) : (
            <>
              <span>Создать заявку</span>
              <ArrowRight className="w-5 h-5" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default DepositScreen;
